var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49294 0.5C3.58294 0.5 0.416687 3.86 0.416687 8C0.416687 12.14 3.58294 15.5 7.49294 15.5C11.41 15.5 14.5834 12.14 14.5834 8C14.5834 3.86 11.41 0.5 7.49294 0.5ZM7.50002 14C4.36919 14 1.83335 11.315 1.83335 8C1.83335 4.685 4.36919 2 7.50002 2C10.6309 2 13.1667 4.685 13.1667 8C13.1667 11.315 10.6309 14 7.50002 14ZM7.34419 4.25H7.30169C7.01835 4.25 6.79169 4.49 6.79169 4.79V8.33C6.79169 8.5925 6.91919 8.84 7.13877 8.975L10.0784 10.8425C10.3192 10.9925 10.6309 10.9175 10.7725 10.6625C10.8081 10.6018 10.8317 10.5341 10.8421 10.4635C10.8524 10.3929 10.8493 10.3208 10.8327 10.2515C10.8162 10.1822 10.7867 10.1171 10.7459 10.0602C10.7051 10.0032 10.654 9.95557 10.5954 9.92L7.85419 8.195V4.79C7.85419 4.49 7.62752 4.25 7.34419 4.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.43949e16f371cca65259903605aac95c.svg";
export { ForwardRef as ReactComponent };